<template>
  <div>
    <v-app-bar
      color="red darken-3"
      dense
      dark
      height="60px"
    >
      <v-toolbar-title>VegaMenu</v-toolbar-title>

      <v-spacer></v-spacer>

      <div class="mr-4 cursor">Kredity: {{userCredit}}</div>
      <v-btn @click="logout" outlined>Odhlásit se</v-btn>
    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'NavigationAppbar',
  methods: {
    logout () {
      this.$http.post('/logout')
        .then(response => {
          this.$store.commit('user/clearUserData')
          this.$router.push('/login')
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  computed: {
    ...mapGetters({
      userCredit: 'user/userCredit'
    })
  }
}
</script>

<style scoped>
  a{
    color: #ffffff;
  }
  .cursor{
    cursor: pointer;
  }
</style>
